import { Icon } from '@asgard/ui-library';
import { faTimes } from '@fortawesome/pro-solid-svg-icons';
import { faXTwitter } from 'components/shared/XTwitterIcon';
import { useI18n } from 'hooks/useI18n';
import React from 'react';
import { Link as LinkScroll } from 'react-scroll';
import { getPublicPath } from 'utils/paths';
import * as S from './Fredcon26MobileMenu.styled';
import { Fredcon26TicketButton } from './Fredcon26TicketButton';
import { TelegramIcon } from './TelegramIcon';

interface Fredcon26MobileMenuProps {
  isOpen: boolean;
  onClose: () => void;
}

export const Fredcon26MobileMenu: React.FC<Fredcon26MobileMenuProps> = ({
  isOpen,
  onClose
}) => {
  const { t } = useI18n('fredcon26');

  const pixelSequence = [
    { color: '#3053f9' },
    { color: '#3053f9', opacity: 0 },
    { color: '#c5fe79' },
    { color: '#3053f9' },
    { color: '#ffb6fb' },
    { color: '#3053f9', opacity: 0 },
    { color: '#3053f9' },
    { color: '#3053f9' },
    { color: '#3053f9' },
    { color: '#ffb6fb' },
    { color: '#3053f9' },
    { color: '#3053f9', opacity: 0 },
    { color: '#3053f9' },
    { color: '#3053f9', opacity: 0 },
    { color: '#c5fe79' },
    { color: '#3053f9' },
    { color: '#3053f9' },
    { color: '#3053f9', opacity: 0 },
    { color: '#ff6e23' },
    { color: '#3053f9', opacity: 0 },
    { color: '#3053f9' },
    { color: '#3053f9' },
    { color: '#836fff' },
    { color: '#c5fe79', opacity: 0 },
    { color: '#3053f9' },
    { color: '#3053f9', opacity: 0 },
    { color: '#3053f9' },
    { color: '#3053f9', opacity: 0 },
    { color: '#ff6e23' },
    { color: '#3053f9', opacity: 0 },
    { color: '#3053f9' },
    { color: '#c5fe79', opacity: 0 },
    { color: '#3053f9' },
    { color: '#3053f9', opacity: 0 },
    { color: '#ffb6fb' },
    { color: '#3053f9' },
    { color: '#836fff' },
    { color: '#3053f9', opacity: 0 },
    { color: '#3053f9' },
    { color: '#3053f9', opacity: 0 },
    { color: '#3053f9' },
    { color: '#836fff' },
    { color: '#c5fe79', opacity: 0 },
    { color: '#3053f9', opacity: 0 },
    { color: '#3053f9', opacity: 0 }
  ];

  return (
    <>
      <S.Overlay isOpen={isOpen} onClick={onClose} />
      <S.MenuPanel isOpen={isOpen}>
        <div className="main">
          <S.MenuHeader>
            <S.HeaderContent>
              <S.HeaderSubTitle>
                {t('fredcon.the-one-and-only')}
              </S.HeaderSubTitle>
              <S.HeaderLogo>
                <img
                  src={getPublicPath('/images/fredcon26/fredcon-logo.png')}
                  alt="Fredcon26 logo"
                />
              </S.HeaderLogo>
            </S.HeaderContent>
            <S.CloseButton onClick={onClose}>
              <Icon icon={faTimes} size="xl" />
            </S.CloseButton>
          </S.MenuHeader>

          <S.MenuItems>
            {[
              { to: 'agenda', label: t('fredcon.header.nav-1') },
              { to: 'donde', label: t('fredcon.header.nav-2') },
              { to: 'speakers', label: t('fredcon.header.nav-3') },
              { to: 'contacto', label: t('fredcon.header.nav-5') }
            ].map((item) => (
              <S.MenuItem key={item.to}>
                <LinkScroll
                  to={item.to}
                  href={`#${item.to}`}
                  smooth={true}
                  duration={500}
                  offset={-64}
                  onClick={onClose}
                  containerId="fredcon-page-wrapper"
                >
                  {item.label}
                </LinkScroll>
                <div className="underline">
                  {Array.from({ length: 4 })
                    .map(() => pixelSequence)
                    .flat()
                    .map((pixel, i) => (
                      <S.Pixel
                        key={i}
                        color={pixel.color}
                        opacity={pixel.opacity}
                      />
                    ))}
                </div>
              </S.MenuItem>
            ))}

            <Fredcon26TicketButton className="menu-ticket-button" />
          </S.MenuItems>
        </div>

        <S.Footer>
          <S.Divider />
          <S.FooterLinks>
            <S.Copyright>
              {t('fredcon.copyright', { year: new Date().getFullYear() })}
            </S.Copyright>
            <S.FooterLink
              href="https://www.getmanfred.com/terms-of-use"
              target="_blank"
            >
              {t('fredcon.footer.nav.terms')}
            </S.FooterLink>
            <S.FooterLink
              href="https://www.getmanfred.com/privacy-policy"
              target="_blank"
            >
              {t('fredcon.footer.nav.privacy')}
            </S.FooterLink>
            <S.FooterLink
              href="https://www.getmanfred.com/cookies"
              target="_blank"
            >
              {t('fredcon.footer.nav.cookies')}
            </S.FooterLink>
            <S.SocialMedia>
              <S.SocialIcon
                href="https://twitter.com/getmanfred"
                target="_blank"
              >
                <Icon icon={faXTwitter} size="5xl" />{' '}
              </S.SocialIcon>
              <S.SocialIcon href="https://t.me/getmanfred" target="_blank">
                <TelegramIcon />
              </S.SocialIcon>
            </S.SocialMedia>
          </S.FooterLinks>
        </S.Footer>

        {/* Decorative squares anchored to the right to prevent overflow */}
        <S.DecorativeSquare color="#c5fe79" top="18%" right="15%" />
        <S.DecorativeSquare
          color="#836FFF"
          top="45%"
          right="10%"
          width="100px"
        />
        <S.DecorativeSquare color="#ff6e23" top="calc(89% - 50px)" right="5%" />
        <S.DecorativeSquare color="#ffb6fb" top="89%" right="calc(5% + 50px)" />
      </S.MenuPanel>
    </>
  );
};
